// Vite resolves "date-fns" to this module so every formatted date is rendered in Spanish.
import {
  format as baseFormat,
  formatDistance as baseFormatDistance,
  formatDistanceStrict as baseFormatDistanceStrict,
  formatDistanceToNow as baseFormatDistanceToNow,
  formatDistanceToNowStrict as baseFormatDistanceToNowStrict,
  formatRelative as baseFormatRelative,
} from 'date-fns/esm/index.js';
import es from 'date-fns/esm/locale/es/index.js';

export * from 'date-fns/esm/index.js';

const withLocale = options => ({ locale: es, ...options });

export const format = (date, pattern, options) =>
  baseFormat(date, pattern, withLocale(options));
export const formatDistance = (date, baseDate, options) =>
  baseFormatDistance(date, baseDate, withLocale(options));
export const formatDistanceStrict = (date, baseDate, options) =>
  baseFormatDistanceStrict(date, baseDate, withLocale(options));
export const formatDistanceToNow = (date, options) =>
  baseFormatDistanceToNow(date, withLocale(options));
export const formatDistanceToNowStrict = (date, options) =>
  baseFormatDistanceToNowStrict(date, withLocale(options));
export const formatRelative = (date, baseDate, options) =>
  baseFormatRelative(date, baseDate, withLocale(options));
